import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "./shared";

const EXP_IMG =
  "https://images.unsplash.com/photo-1638638977172-9f7169a77930?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxibGFjayUyMGFuZCUyMHdoaXRlJTIwcG9ydHJhaXQlMjBwaG90b2dyYXBoeXxlbnwwfHx8fDE3ODQwODEzNTB8MA&ixlib=rb-4.1.0&q=85";

const CHAPTERS = [
  "Our digital media production team is seeking confident, reliable, and expressive adults (18 years or older) to collaborate on legal, subscription-based internet media and creative digital content.",
  "No previous industry experience is required. We welcome applications from solo creators (female or trans-female) as well as established or new on-screen creative duos.",
  "All production takes place in private, secure, and highly respectful environments.",
  "We operate under strict digital privacy protocols. Your personal identity is kept entirely confidential.",
  "Consent is non-negotiable. It is treated as an active, ongoing process that is respected at every phase of production.",
];

const Experience = () => (
  <section
    id="experience"
    data-testid="experience-section"
    className="relative bg-[#0a0a0a] py-24 lg:py-32 border-t border-white/5"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-14 lg:gap-20 items-start">
      <div>
        <SectionLabel number="01" title="Who We Are" />
        <Reveal>
          <h2 className="font-display text-white font-extrabold tracking-tighter uppercase text-4xl sm:text-5xl leading-none mb-10">
            Professional
            <br />
            Experience
          </h2>
        </Reveal>

        <div className="space-y-8">
          {CHAPTERS.map((text, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div className="flex gap-5" data-testid={`chapter-${i + 1}`}>
                <span className="font-display text-[#d4af37]/70 text-sm font-semibold pt-1 tabular-nums">
                  0{i + 1}
                </span>
                <p className="text-[#cccccc] leading-relaxed text-base flex-1 border-l border-white/10 pl-5">
                  {text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.15} className="md:sticky md:top-28">
        <div className="relative overflow-hidden group">
          <div className="absolute -inset-px border border-[#d4af37]/30 z-10 pointer-events-none" />
          <motion.img
            src={EXP_IMG}
            alt="Artistic black and white portrait"
            className="w-full h-[520px] lg:h-[640px] object-cover grayscale transition-transform duration-[1.2s] ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          <div className="absolute bottom-6 left-6 z-20">
            <p className="text-[#d4af37] text-xs tracking-[0.3em] uppercase">
              Privacy &middot; Expression
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Experience;
